import React, { Fragment } from 'react'
import classnames from 'classnames'

const RadioButton = ({ id, label, className, classic, ...props }) => {
  const classes = classnames(
    'radio-group__input',
    className
  );

  return (
    <Fragment>
      <input
        type="radio"
        id={id}
        className={classes}
        { ...props }
      />
      <label
        htmlFor={id}
        className="radio-group__label"
      >
        {label}
      </label>
    </Fragment>
  );
};

export default RadioButton
